import { AffiliateHero } from '@/components/affiliate/AffiliateHero'
import { RewardCard } from '@/components/affiliate/RewardCard'
import { AffiliateProgramBanner } from '@/components/affiliate/AffiliateProgramBanner'
import { Footer } from '@/components/layout/footer'
import { PageShell } from '@/components/layout/PageShell'

export default function Affiliate() {
	return (
		<PageShell footer={<Footer />}>
			<AffiliateHero />

			<div className='grid grid-cols-1 gap-4 lg:grid-cols-2'>
				<RewardCard
					heading={
						<>
							<span className='text-foreground'>Get your </span>
							<span className='bg-gradient-to-r from-[hsl(var(--accent-blue))] to-[hsl(var(--accent-green))] bg-clip-text text-transparent'>1000 BECY</span>
							<span className='text-foreground'> referral rewards</span>
						</>
					}
					description='Every friend you invite? will get you 1000 BECY, the more you invite, the more you will get!'
					image='/images/affiliate/cpa_reward.png'
				/>
				<RewardCard
					heading={
						<>
							<span className='text-foreground'>Get your </span>
							<span className='bg-gradient-to-r from-[hsl(var(--accent-blue))] to-[hsl(var(--accent-green))] bg-clip-text text-transparent'>25%</span>
							<span className='text-foreground'> commission rewards</span>
						</>
					}
					description='You will receive commission rewards every time your friends place wager based on the game'
					image='/images/affiliate/commission_reward.png'
				/>
			</div>

			<AffiliateProgramBanner />
		</PageShell>
	)
}
